import _Drawer from './Drawer';

export const Drawer = _Drawer;
export default _Drawer;



// WEBPACK FOOTER //
// ./src/js/components/Drawer/index.js